export default __webpack_public_path__ + "static/media/global-platform-background.af97ff0e.png";